// Generate a URL-friendly slug from Persian/English text
export default function generateSlug(text) {
  if (!text) return "";
  
  // Convert Persian numbers to English
  const persianToEnglish = {
    '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
    '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9'
  };
  
  let slug = text.toString();
  
  // Replace Persian numbers
  Object.keys(persianToEnglish).forEach(persian => {
    slug = slug.replace(new RegExp(persian, 'g'), persianToEnglish[persian]);
  });
  
  // Convert to lowercase
  slug = slug.toLowerCase();
  
  // Replace spaces and special characters with hyphens
  slug = slug
    .replace(/\s+/g, '-')           // Replace spaces with hyphens
    .replace(/[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFFa-z0-9-]/g, '') // Remove special chars but keep Persian/Arabic
    .replace(/-+/g, '-')            // Replace multiple hyphens with single hyphen
    .replace(/^-|-$/g, '');         // Remove leading/trailing hyphens
  
  return slug;
}

